<template>
  <div>
    <el-form ref="formData" :model="formData" size="mini">
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.table_label_production_order_delivery_date') ||
                '工厂交期'
            "
          >
            <el-input v-model="formData.deliveryDate" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.table_label_production_order_shipment_date') ||
                '客户交期'
            "
          >
            <el-input v-model="formData.shipmentDate" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.table_label_deliveryType') || '出货方式'"
          >
            <el-input v-model="formData.v_deliveryType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('INDEX.order_packing_outBillType') || '出单类型'"
            v-if="formData.orderType !== 'domesticTrade'"
          >
            <el-input v-model="formData.v_outBillType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="
              $l('INDEX.table_label_production_order_retailer_po') || '零售商PO'
            "
          >
            <el-input v-model="formData.retailerPo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.order_form_label_importerPo') || '代理商PO'"
          >
            <el-input v-model="formData.importerPo" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'
            "
            v-if="formData.orderType !== 'domesticTrade'"
          >
            <el-input v-model="formData.dispatchPortName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_destinationPort') || '目的港口'
            "
            v-if="formData.orderType !== 'domesticTrade'"
          >
            <el-input v-model="formData.destinationPortName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_identifyNo') || '批次识别单号'
            "
          >
            <el-input v-model="formData.identifyNo" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_receiverPhone') || '收货人'">
            <el-input v-model="formData.receiver" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_receiverPhone') || '联系电话'">
            <el-input v-model="formData.receiverPhone" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('INDEX.form_receiverAddress') || '收货地址'">
            <el-input v-model="formData.receiverAddress" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('INDEX.tab_demand_packing') || '装箱方案'">
            <el-input v-model="formData.demandPacking" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_batch_total_bo_qty') ||
                '批次总数'
            "
          >
            <el-input v-model="formData.totQty" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_batch_total_box_qty') ||
                '批次总箱数'
            "
          >
            <el-input v-model="formData.totBoxQty" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div>
            <span>
              {{
                $l('INDEX.form_label_production_order_package') || '外包装箱'
              }}
              ：
              {{ formData.demandPackage || '--' }}
            </span>
          </div>
        </el-col>
      </el-row>

      <GoodsTable :orderBatchCode="orderBatchCode">
        <div class="side-frame-success" slot="header">
          <span style="font-size: 14px; color: #606266">
            {{ $l('INDEX.table_label_product_information') || '产品信息' }}
          </span>
        </div>
      </GoodsTable>
    </el-form>
  </div>
</template>

<script>
import GoodsTable from '../goods-table'
export default {
  components: { GoodsTable },
  props: { orderBatchCode: { type: String, default: '' } },
  data() {
    return {
      formData: { orderType: 'domesticTrade' },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderBatchCode) return
      this.$api
        .pendingOrderBatchDetailApi({ orderBatchCode: this.orderBatchCode })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
